var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYouxiang6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7V3.5a.5.5 0 00-.5-.5H2.25a.5.5 0 00-.5.5v9a.5.5 0 00.5.5H8.3",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 3l5.556 3.704a.8.8 0 00.888 0L14 3",
    stroke: "#3F465C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.02 12.127a2.057 2.057 0 010-.754l-.507-.29a.226.226 0 01-.083-.31l.467-.8a.226.226 0 01.307-.082l.509.291c.193-.163.415-.292.659-.378v-.578c0-.125.101-.226.226-.226h.936c.124 0 .225.101.225.226v.578c.244.086.467.215.66.378l.508-.291a.226.226 0 01.308.082l.466.8a.226.226 0 01-.083.31l-.506.29c.047.25.047.505 0 .754l.506.29a.226.226 0 01.083.31l-.466.8a.226.226 0 01-.307.082l-.51-.291a2.082 2.082 0 01-.659.378v.578a.226.226 0 01-.225.226h-.936a.226.226 0 01-.226-.226v-.578a2.082 2.082 0 01-.66-.378l-.508.291a.226.226 0 01-.307-.082l-.467-.8a.226.226 0 01.083-.31l.506-.29zm2.046.31a.687.687 0 100-1.374.687.687 0 000 1.374z",
    fill: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_youxiang6.0818ddbe.svg";
export { SvgTongyongYouxiang6 as ReactComponent };